export function safeJSONStringify(data: any): string | undefined {
    try {
        return JSON.stringify(data);
    } catch (error) {
        if (window.OK.Tracer) {
            window.OK.Tracer.error(error);
        }
    }
}
